import { css } from "@emotion/react";
import styled from "@emotion/styled";

const sectionStyles = props => {
  switch (props.variant) {
    case "qualities":
      return css`
        padding: 40px 0 50px;

        @media (min-width: ${props.theme.screenSizes.mdMax}) {
          padding: 70px 0;
        }
      `;
    case "start":
      return css`
        padding: 24px 0;

        @media (min-width: ${props.theme.screenSizes.mdMax}) {
          padding: 48px 0 70px;
        }
      `;
    case "startTop":
      return css`
        padding-top: 24px;

        @media (min-width: ${props.theme.screenSizes.mdMax}) {
          padding-top: 48px;
        }
      `;
    case "startProxy":
      return css`
        padding-top: 24px;

        @media (min-width: ${props.theme.screenSizes.mdMax}) {
          padding-top: 0px;
        }
      `;
    case "innerTools":
      return css`
        padding: 24px 0;

        @media (min-width: ${props.theme.screenSizes.mdMax}) {
          padding: 70px 0;
        }
      `;

    case "subscribe":
      return css`
        background-color: ${props.theme.colors.black};
        margin-top: 100px;
        padding-top: 48px;
        padding-bottom: 60px;
        margin-bottom: -70px;

        @media (min-width: ${props.theme.screenSizes.mdMax}) {
          padding-top: 80px;
          padding-bottom: 63px;
        }
      `;

    default:
      return css`
        padding: 50px 0;

        @media (min-width: ${props.theme.screenSizes.mdMax}) {
          padding: 70px 0;
        }
      `;
  }
};

export const Section = styled.section`
  ${props => sectionStyles(props)}
`;
